import {
  createDirectus,
  rest,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
  aggregate,
  updateItems,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(limit, offset, filter, sort, fields) {
  let query = {
    limit,
    offset,
    fields: fields
      ? fields
      : [
          "*,groups.groups_id.*,person_id.*,company_id.*,agent_id.*,agent_id.person_id.*",
        ],
  };
  if (sort) query.sort = sort;
  if (Object.keys(filter).length !== 0) {
    query.filter = filter;
  }
  const totalCount = await client.request(
    aggregate("contacts", {
      aggregate: { count: "*" },
      query: { filter },
    })
  );

  const data = await client.request(readItems("contacts", query));
  return { totalCount: totalCount[0].count, data };
}

async function getGroupsByIds(ids) {
  let obj = {
    filter: { contact_id: { _in: ids } },
  };
  const data = await client.request(readItems("contacts_groups", obj));

  return data;
}

async function getById(id) {
  return await client.request(
    readItem("contacts", id, {
      fields: [
        "*,groups.groups_id.*,person_id.*,company_id.*,agent_id.*,agent_id.person_id.*",
      ],
    })
  );
}
async function create(data) {
  let person_id = "";
  if (data.person_id) person_id = data.person_id;
  else {
    const person = await client.request(
      createItem("persons", {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
    person_id = person.id;
  }

  return await client.request(
    createItem(
      "contacts",
      {
        person_id: person_id,
        company_id: data.company_id,
        job_position: data.job_position,
        priority: data.priority,
        agent_id: data.agent_id,
        groups: data.groups,
      },
      {
        fields: [
          "*,groups.groups_id.*,person_id.*,company_id.*,agent_id.*,agent_id.person_id.*",
        ],
      }
    )
  );
}

async function updateById(id, data) {
  if (!data.person_id) {
    const person = await client.request(
      createItem("persons", {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
    data.person_id = person.id;
  } else {
    await client.request(
      updateItem("persons", data.person_id, {
        name: data.name,
        email: data.email,
        phone: data.phone,
        birthday: data.birthday,
        address: data.address,
        comment: data.comment,
      })
    );
  }
  return await client.request(
    updateItem(
      "contacts",
      id,
      {
        person_id: data.person_id,
        company_id: data.company_id,
        job_position: data.job_position,
        priority: data.priority,
        agent_id: data.agent_id,
        groups: data.groups,
      },
      {
        fields: [
          "*,groups.groups_id.*,person_id.*,company_id.*,agent_id.*,agent_id.person_id.*",
        ],
      }
    )
  );
}

async function update(items, data) {
  return await client.request(
    updateItems("contacts", items, data, {
      fields: [
        "*,groups.groups_id.*,person_id.*,company_id.*,agent_id.*,agent_id.person_id.*",
      ],
    })
  );
}

async function deleteById(id) {
  return await client.request(deleteItem("contacts", id));
}
export default {
  get,
  create,
  update,
  deleteById,
  getById,
  updateById,
  getGroupsByIds,
};
